import { useContext, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'

import { ModalFormsContext } from 'components/modals'
import {
    start3dSecureCard,
    start3dSecureCompanyPaymentByCard,
    start3dSecureCompanyPaymentByOnlineBanking,
    start3dSecureOnlineBank,
} from 'redux/ledger/ledger-actions'
import { selectSuccess } from 'redux/ledger/ledger-select'

const Handler3DSecure = () => {
    const location = useLocation()
    const dispatch = useDispatch()
    const success = useSelector(selectSuccess)
    const navigate = useNavigate()
    const { modalValues } = useContext(ModalFormsContext)

    const cardDepositPath = location?.pathname === '/card-deposit'
    const bankDepositPath = location?.pathname === '/bank-deposit'
    const companyCardPaymentPath = location?.pathname === '/company-card-payment'
    const companyOnlineBankingPaymentPath = location?.pathname === '/company-online-bank-payment'

    useEffect(() => {
        if (!!cardDepositPath && !!success?.SECURE_3D_CARD) {
            modalValues.handleModalOpen({ modal: 'PathHandlerModal', component: 'DepositByCardHandler' })
            window.history.replaceState('', document.title, '/')
        }
        if (!!bankDepositPath && !!success?.SECURE_3D_ONLINE_BANK) {
            modalValues.handleModalOpen({ modal: 'PathHandlerModal', component: 'DepositByOnlineBankHandler' })
            window.history.replaceState('', document.title, '/')
        }
        if (!!companyCardPaymentPath && !!success?.SECURE_3D_COMPANY_CARD_PAYMENT) {
            modalValues.handleModalOpen({ modal: 'PathHandlerModal', component: 'CompanyPaymentByCardHandler' })
            window.history.replaceState('', document.title, '/')
        }
        if (!!companyOnlineBankingPaymentPath && !!success?.SECURE_3D_COMPANY_ONLINE_BANKING_PAYMENT) {
            modalValues.handleModalOpen({ modal: 'PathHandlerModal', component: 'CompanyPaymentByOnlineBankingHandler' })
            window.history.replaceState('', document.title, '/')
        }
    }, [success, cardDepositPath, bankDepositPath, companyCardPaymentPath])

    const start3dSecure = () => {
        if (!!cardDepositPath || !!bankDepositPath || !!companyCardPaymentPath || !!companyOnlineBankingPaymentPath) {
            const id = new URLSearchParams(location?.search).get('id')

            if (id) {
                !!cardDepositPath && dispatch(start3dSecureCard({ id }))
                !!bankDepositPath && dispatch(start3dSecureOnlineBank({ id }))
                !!companyCardPaymentPath && dispatch(start3dSecureCompanyPaymentByCard({ id }))
                !!companyOnlineBankingPaymentPath && dispatch(start3dSecureCompanyPaymentByOnlineBanking({ id }))
            } else {
                navigate('/not-found')
            }
        }
    }

    return { start3dSecure }
}

export default Handler3DSecure
